<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('company.notifications') }}</span></li>
				</ul>
			</div>
		</div>

		<div id="notifications_toolbar" class="toolbar">
			<button id="notifications_table_toolbar_add" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
			<button id="notifications_table_toolbar_remove" :title="$t('delete')">
				<span uk-icon="trash"></span>
				<span class="title">{{ $t('delete') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-show="isPreloader" uk-spinner class="spinner"></div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li>
					<a tabindex="-1">{{ $t('edit') }}</a>
				</li>
				<li><a tabindex="-1">{{ $t('delete') }}</a></li>
			</ul>
		</div>

		<NotificationModal :company-id="id" v-if="isVisibleModal" @close-modal="closeHandlerModal" />
	</div>
</template>

<script>
import { USER_CONFIG } from 'actions/user'
import { NotificationsManager } from '@/core/administration/NotificationsManager'
import { resizeTableHeight, Table, toggleSearchForm } from '@/core/support_gui_components/table/table'
import { bindResetButton } from '@/core/input_controls/button/button'
import { removeTabindex, showMessageAlert } from '@/core/shared'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import { enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'
import NotificationModal from 'components/modal/NotificationModal'

export default {
	name: 'CompanyNotifications',
	components: {
		NotificationModal
	},
	props: [
		'id',
		'admin'
	],
	data() {
		return {
			isVisibleModal: false,
			isPreloader: false
		}
	},
	metaInfo () {
		return {
			title: this.$t('company.notifications')
		}
	},
	mounted () {
		let tableColumns = [
			{
				'checkbox': true
			},
			{
				'title': 'name',
				'columnName': 'name',
				'attribute': 'name'
			},
			{
				'title': 'event.type',
				'columnName': 'event',
				'attribute': 'event'
			},
			{
				'title': 'export.config',
				'columnName': 'exportConfigId',
				'attribute': 'export_config_id'
			}
		]

		window.itemStructure = {
			'phase': { 'type': 'S' }
		}

		let companyId = this.id || this.$store.getters.getProfile.companyId
		let vm = this

		window.manager = new NotificationsManager(companyId)
		manager.loadExportConfigs()

		this.$store.dispatch(USER_CONFIG, 'notificationsTable.tableState')
			.then((config) => {
				window.table = new Table('notificationsTable', {
						selector: '#table',
						columns: tableColumns,
						dynamicLoading: true,
						contextMenu: '#context-menu',
						doubleClickMode: 'edit',
						sortingSupport: true,
						cellsSelectionsSupport: true,
						itemsSelectionsSupport: true,
						frozenFirstColumn: true,
						restoringSupport: true,
						filterPreProcessor: function (filter) {
							var newFilter = {}
							for (var fieldName in filter) {
								newFilter[fieldName] = filter[fieldName]['val']
							}
							return newFilter
						}
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								initNotificationsManager('edit', item, item.companyId, attribute)
							},
							2: function (item, attribute) {
								manager.deleteNotification(item, table)
							}
						},
						doubleClick: {
							'edit': function (item, table) {
								table.callbacks.contextMenu['1'](item, table.selectedAttribute)
							}
						}
					},
					function (data) {
						manager.prepareData(data)
					})
				table.setSavedState(config)
				table.setDataUrl(window.urlContext + 'company/' + companyId + '/notifications/load')
				table.setDataIDsUrl(window.urlContext + 'company/' + companyId + '/notifications/ids')
				table.setDataSortUrl(window.urlContext + 'company/' + companyId + '/notifications/sort')
				table.initTable()

				bindResetButton()
				removeTabindex()

				setToolbarMode(table.selectedItemsMode)
				initFilterForm(itemStructure, table)
				enableMulticheckboxSupport({ selector: '.multicheckbox-filter' })
				enableHotkeyForSearch(itemStructure, table)
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG notificationsTable', error)
			})

		// toolbar buttons
		$('#table_toolbar_search').bind('click', toggleSearchForm)
		$('#notifications_table_toolbar_add').click(function () {
			initNotificationsManager('create', {}, companyId, undefined)
		})
		$('#notifications_table_toolbar_remove').bind('click', function () {
			var ids = table.selectedItemsManager.getSelections()
			if (_.isEmpty(ids)) {
				showMessageAlert('no.selected.notifications', 'warning')
			} else {
				manager.deleteNotifications(ids, table)
			}
		})

		function initNotificationsManager (action, notification, companyId, activeAttribute) {
			manager.setProperties({
				action: action,
				activeAttribute: activeAttribute,
				notification: notification,
				companyId: companyId,

				postSaveAction: function () {
					table.initTable()
				}
			})
			vm.isVisibleModal = true
		}

		$(window).resize(function () {
			resizeTableHeight()
			table.frozenTableElements.setFrozenHeaderCellsWidth()
			table.frozenTableElements.setFrozenColumnCellsHeight()
		})
	},
	methods: {
		closeHandlerModal: function () {
			this.isVisibleModal = false
		}
	}
}
</script>

<style scoped>
.spinner {
	/*width: 10px;*/
}
</style>
